import { Link } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import {
  ARENA_EXPORTER_DOWNLOAD_HREF,
  ARENA_EXPORTER_FILENAME,
} from "../constants/arenaExporter";
import { BentoCard, PageIntro, Surface } from "../components/Visual";
import { Icon } from "../components/Icons";

export function Downloads() {
  const { firebaseUser } = useAuth();

  return (
    <main className="page container downloads-page">
      <PageIntro
        eyebrow="Downloads"
        icon="download"
        title={<>Arena collection <span className="grad">exporter.</span></>}
        body={
          <>
            A small Windows utility reads your MTG Arena collection from memory
            while the game is running and saves <code>mtga_collection.json</code>
            on your PC.
          </>
        }
      />

      <Surface tone="foil" className="download-hero-panel">
        <div>
          <span className="price-card-kicker"><Icon name="shield" size={16} /> Local-first utility</span>
          <h2>Download MTGDeckBuilder</h2>
          <p>
            The exporter runs locally; it does not upload your collection. You
            copy the JSON into Foil Bloom yourself.
          </p>
        </div>
        <a
          className="topbar-btn primary"
          href={ARENA_EXPORTER_DOWNLOAD_HREF}
          download={ARENA_EXPORTER_FILENAME}
        >
          <Icon name="download" size={16} />
          Download
        </a>
      </Surface>

      <div className="bento-grid download-steps">
        <BentoCard icon="rocket" title="Launch Arena">
          <p>
            Open MTG Arena and go to Decks or Collection. Scroll through your
            collection for about half a minute so it is loaded in memory.
          </p>
        </BentoCard>
        <BentoCard icon="activity" title="Run the exporter">
          <p>
            Run <code>{ARENA_EXPORTER_FILENAME}</code>. If access is denied, try
            Run as administrator. Follow the prompts and enter a few anchor cards.
          </p>
        </BentoCard>
        <BentoCard icon="upload" title="Import in Foil Bloom">
          <p>
            Open <code>mtga_collection.json</code>, copy the contents, and paste
            into Collection. You can also drop the file onto the import area.
          </p>
        </BentoCard>
      </div>

      <div className="download-notes-grid">
        <Surface className="download-notes">
          <h3>Troubleshooting</h3>
          <ul>
            <li>If the scan fails, scroll the in-game collection again and retry.</li>
            <li>Rarer anchor cards, like legends, often work better than commons.</li>
            <li>Windows SmartScreen may warn on first run because the build is not code-signed.</li>
          </ul>
        </Surface>

        <Surface className="download-notes">
          <h3>Attribution</h3>
          <p>
            Derived from{" "}
            <a href="https://github.com/NthPhantom10/MTGA-collection-exporter" target="_blank" rel="noreferrer">
              MTGA Collection Exporter
            </a>{" "}
            (MIT License).
          </p>
        </Surface>
      </div>

      <p className="download-actions">
        {firebaseUser ? (
          <Link to="/collection" className="topbar-btn primary">
            <Icon name="archive" size={16} />
            Open Collection import
          </Link>
        ) : (
          <>
            <Link to="/register" className="topbar-btn primary">
              <Icon name="sparkles" size={16} />
              Create free account
            </Link>{" "}
            <Link to="/login" className="topbar-btn">
              <Icon name="login" size={16} />
              Sign in
            </Link>
            <span className="muted">Collection import requires an account.</span>
          </>
        )}
      </p>
    </main>
  );
}
